<template>
    <customer-layout>
    <div class="w-full min-h-screen pb-12 bg-gray-100">
        
        <div class="w-full px-8 py-4 mx-auto md:max-w-screen-xl">
            <div v-if="user.gems > 0" class="pt-2 pb-4">
                <p class="pb-2 font-light">{{ user.name }}, {{ $t('you have already conquered') }} {{ user.gems}} OSM Coin</p>
                <!-- <ul class="flex flex-wrap w-full">
                    <li v-for="gem in user.gems" :key="gem" class="w-1/12">
                    <img src="/img/osm-coin.png" alt="gem" style="max-width:50px; margin:0 auto">
                    </li>
                </ul> -->
                <inertia-link href="/howto" class="block w-full px-3 py-1 mt-4 font-bold text-center text-white bg-green-500 rounded-lg hover:bg-blue-600">{{ $t('Find out how to earn more') }} OSM Coin</inertia-link>
            </div>

            <div class="w-full mx-auto md:max-w-screen-xl">
      
                <h3 class="py-2 text-xl font-bold">{{ $t('Awards') }}</h3>
                <ul class="flex flex-wrap w-full">
                    <li class="flex flex-row w-full px-4 py-6 mb-2 bg-white rounded-lg shadow-md md:w-6/12 lg:w-4/12 h-22">
                        <div class="w-2/12">
                            <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            <h6 class="font-bold text-center text-pink-600">100</h6>
                        </div>
                        <div class="w-10/12 px-2">
                            <h6><span class="font-bold">{{ $t('Discount coupon') }} 100 euro</span> {{ $t('from OSM or request that your OSM COIN be transferred to your wallet') }} <a href="https://www.osmcoin.it/" target="blank" class="text-pink-600">osmcoin.it</a> ({{ $t('to do this you will need to be registered on') }} <a href="https://www.osmcoin.it/" target="blank" class="text-pink-600">osmcoin.it</a> {{ $t('and have provided your personal details') }})</h6>
                            <div v-if="coin_100_prize.length != 0 ">
                                <p class="px-3 py-1 mt-1 bg-blue-300 rounded-lg">{{ $t('you have already claimed this award') }}</p>
                            </div>
                            <div v-else>
                                <div v-show="!ask_1">
                                    <span  v-if="user.gems < 100" class="py-3 text-xs font-semibold text-pink-600">{{ $t('win at least') }} 100 OSM Coins</span>
                                    <form v-else @submit.prevent="submitCoin100">
                                        <div>
                                            <label for="request_type">
                                                <select v-model="requestType100" class="w-full px-2 py-1 border border-gray-200 rounded-md focus:outline-none" id="request_type">
                                                    <option value= null>seleziona premio</option>
                                                    <option value= 1>Buono sconto</option>
                                                    <option value= 2>Trasferisci su osmcoin.it</option>
                                                </select>
                                            </label>
                                            <button type="submit" :disabled="!isComplete100" :class="isComplete100 ? '' : 'opacity-50 cursor-not-allowed'" @click="ask_1 = true" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-white uppercase bg-pink-600 rounded-full">{{ $t('request') }}</button>
                                        </div>
                                    </form>
                                </div>
                                <div v-show="ask_1">
                                    <p class="font-bold text-green-600">{{ $t('Request sent! You will receive confirmation by email') }}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="flex flex-row w-full px-4 py-6 mb-2 bg-white rounded-lg shadow-md md:w-6/12 lg:w-4/12 h-22">
                        <div class="w-2/12">
                            <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            <h6 class="font-bold text-center text-pink-600">150</h6>
                        </div>
                        <div class="w-10/12 px-2">
                            <h6><span class="font-bold">{{ $t('Discount coupon') }} 200 euro</span> {{ $t('from OSM or request that your OSM COIN be transferred to your wallet') }} <a href="https://www.osmcoin.it/" target="blank" class="text-pink-600">osmcoin.it</a> ({{ $t('to do this you will need to be registered on') }} <a href="https://www.osmcoin.it/" target="blank" class="text-pink-600">osmcoin.it</a> {{ $t('and have provided your personal details') }})</h6>
                            <div v-if="coin_150_prize.length != 0 ">
                                <p class="px-3 py-1 mt-1 bg-blue-300 rounded-lg">{{ $t('you have already claimed this award') }}</p>
                            </div>
                            <div v-else>
                                <div v-show="!ask_2">
                                    <span v-if="user.gems < 150" class="py-3 text-xs font-semibold text-pink-600">{{ $t('win at least') }} 150 OSM Coin</span>
                                    <form v-else @submit.prevent="submitCoin150">
                                        <div>
                                            <label for="request_type">
                                                <select v-model="requestType150" class="w-full px-2 py-1 border border-gray-200 rounded-md focus:outline-none" id="request_type">
                                                    <option value= null>seleziona premio</option>
                                                    <option value= 1>Buono sconto</option>
                                                    <option value= 2>Trasferisci su osmcoin.it</option>
                                                </select>
                                            </label>
                                            <button type="submit" :disabled="!isComplete150" :class="isComplete150 ? '' : 'opacity-50 cursor-not-allowed'" @click="ask_2 = true" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-white uppercase bg-pink-600 rounded-full">{{ $t('request') }}</button>
                                        </div>
                                    </form>
                                </div>
                                <div v-show="ask_2">
                                    <p class="font-bold text-green-600">{{ $t('Request sent! You will receive confirmation by email') }}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="flex flex-row w-full px-4 py-6 mb-2 bg-white rounded-lg shadow-md md:w-6/12 lg:w-4/12 h-22">
                        <div class="w-2/12">
                            <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            <h6 class="font-bold text-center text-pink-600">300</h6>
                        </div>
                        <div class="w-10/12 px-2">
                            <h6><span class="font-bold">{{ $t('Discount coupon') }} 500 euro</span> {{ $t('from OSM or request that your OSM COIN be transferred to your wallet') }} <a href="https://www.osmcoin.it/" target="blank" class="text-pink-600">osmcoin.it</a> ({{ $t('to do this you will need to be registered on') }} <a href="https://www.osmcoin.it/" target="blank" class="text-pink-600">osmcoin.it</a> {{ $t('and have provided your personal details') }})</h6>
                            <div v-if="coin_300_prize.length != 0 ">
                                <p class="px-3 py-1 mt-1 bg-blue-300 rounded-lg">{{ $t('you have already claimed this award') }}</p>
                            </div>
                            <div v-else>
                                <div v-show="!ask_3">
                                    <span v-if="user.gems < 300" class="py-3 text-xs font-semibold text-pink-600">{{ $t('win at least') }} 300 OSM Coin</span>
                                    <form v-else @submit.prevent="submitCoin300">
                                        <div>
                                            <label for="request_type">
                                                <select v-model="requestType300" class="w-full px-2 py-1 border border-gray-200 rounded-md focus:outline-none" id="request_type">
                                                    <option value= null>seleziona premio</option>
                                                    <option value= 1>Buono sconto</option>
                                                    <option value= 2>Trasferisci su osmcoin.it</option>
                                                </select>
                                            </label>
                                            <button type="submit" :disabled="!isComplete300" :class="isComplete300 ? '' : 'opacity-50 cursor-not-allowed'" @click="ask_3 = true" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-white uppercase bg-pink-600 rounded-full">{{ $t('request') }}</button>
                                        </div>
                                    </form>
                                </div>
                                <div v-show="ask_3">
                                    <p class="font-bold text-green-600">{{ $t('Request sent! You will receive confirmation by email') }}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="flex flex-row w-full px-4 py-6 mb-2 bg-white rounded-lg shadow-md md:w-6/12 lg:w-4/12 h-22">
                        <div class="w-2/12">
                            <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            <h6 class="font-bold text-center text-pink-600">500</h6>
                        </div>
                        <div class="w-10/12 px-2">
                            <h6><span class="font-bold">{{ $t('Leadership Course') }} OSM</span> {{ $t('or a participation in the MBS School of Management') }}</h6>
                            <div v-if="coin_500_prize.length != 0 ">
                                <p class="px-3 py-1 mt-1 bg-blue-300 rounded-lg">{{ $t('you have already claimed this award') }}</p>
                            </div>
                            <div v-else>
                                <div v-show="!ask_4">
                                    <span v-if="user.gems < 500" class="py-3 text-xs font-semibold text-pink-600">{{ $t('win at least') }} 500 OSM Coin</span>
                                    <form v-else @submit.prevent="submitCoin500">
                                        <div>
                                            <label for="request_type">
                                                <select v-model="requestType500" class="w-full px-2 py-1 border border-gray-200 rounded-md focus:outline-none" id="request_type">
                                                    <option value= null>seleziona premio</option>
                                                    <option value= 1>Buono sconto</option>
                                                    <option value= 2>Trasferisci su osmcoin.it</option>
                                                </select>
                                            </label>
                                            <button type="submit" :disabled="!isComplete500" :class="isComplete500 ? '' : 'opacity-50 cursor-not-allowed'" @click="ask_4 = true" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-white uppercase bg-pink-600 rounded-full">{{ $t('request') }}</button>
                                        </div>
                                    </form>
                                </div>
                                <div v-show="ask_4">
                                    <p class="font-bold text-green-600">{{ $t('Request sent! You will receive confirmation by email') }}</p>
                                </div>
                            </div>
                        </div>
                    </li>

                    <!-- <li class="flex flex-row w-full px-4 py-6 mb-2 bg-white rounded-lg shadow-md md:w-6/12 lg:w-4/12 h-22">
                        <div class="w-2/12">
                            <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            <h6 class="text-center text-blue-900">500</h6>
                        </div>
                        <div class="w-10/12 px-2">
                            <h6>Corso Leadership OSM o una partecipazione alla Scuola di Management MBS</h6>
                            <div v-show="!ask_5">
                                <span v-if="user.gems < 500" class="py-3 text-xs text-blue-900">conquista almeno 500 OSM Coin</span>
                                <form v-else @submit.prevent="submit500">
                                <button type="submit" @click="ask_5 = true" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-white uppercase bg-pink-600 rounded-full">richiedi</button>
                                </form>
                            </div>
                            <div v-show="ask_5">
                                <p class="font-bold text-green-600">Richiesta inviata! Riceverai la conferma via email</p>
                            </div>
                        </div>
                    </li> -->
                </ul>
            </div>
        </div>
        <BottomBar :diamonds="diamonds"/>
    </div>
    </customer-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import BottomBar from "@/Layouts/BottomBar";
    import CustomerLayout from '@/Layouts/CustomerLayout.vue';

    export default {
        props: ["user", "survey", "workout", "diamonds", "coin_100_prize", "coin_150_prize", "coin_300_prize", "coin_500_prize", ],
        components: {
            AppLayout,
            BottomBar,
            CustomerLayout
        },
        data() {
          return {
            ask_1: false,
            ask_2: false,
            ask_3: false,
            ask_4: false,
            ask_5: false,
            prize_100: 100,
            prize_150: 150,
            prize_300: 300,
            prize_500: 500,
            requestType100: null,
            requestType150: null,
            requestType300: null,
            requestType500: null
          };
        },
        computed: {
            isComplete100() {
                return this.requestType100;
            },
            isComplete150() {
                return this.requestType150;
            },
            isComplete300() {
                return this.requestType300;
            },
            isComplete500() {
                return this.requestType500;
            },
        },
        methods: {
          submitCoin100() {
            const data = new FormData()
            data.append('prize', this.prize_100);
            data.append('request_type', this.requestType100);

            this.$inertia.post(this.route('prize.store'), data, {
              onStart: () => this.sending = true,
              onFinish: () => this.sending = false,
            })
          },
          submitCoin150() {
            const data = new FormData()
            data.append('prize', this.prize_150);
            data.append('request_type', this.requestType150);

            this.$inertia.post(this.route('prize.store'), data, {
              onStart: () => this.sending = true,
              onFinish: () => this.sending = false,
            })
          },
          submitCoin300() {
            const data = new FormData()
            data.append('prize', this.prize_300);
            data.append('request_type', this.requestType300);

            this.$inertia.post(this.route('prize.store'), data, {
              onStart: () => this.sending = true,
              onFinish: () => this.sending = false,
            })
          },
          submitCoin500() {
            const data = new FormData()
            data.append('prize', this.prize_500);
            data.append('request_type', this.requestType500);

            this.$inertia.post(this.route('prize.store'), data, {
              onStart: () => this.sending = true,
              onFinish: () => this.sending = false,
            })
          }
        }
    }
</script>